import WebApp from '@twa-dev/sdk';

import {
  getCloudStorageValue,
  removeCloudStorageValue,
} from '@/shared/helpers/cloud-storage';

import { DEFAULT_LOCALE, LS_FORCE_LOCALE_KEY, LS_LOCALE_KEY } from '../constants';
import { isValidLocale } from '../helpers';
import { type Languages } from '../types';

export const getAppLocale = async (): Promise<Languages> => {
  const forcedLocale = (await getCloudStorageValue(LS_FORCE_LOCALE_KEY))?.toLowerCase();

  if (forcedLocale) {
    if (isValidLocale(forcedLocale)) return forcedLocale;
    void removeCloudStorageValue(LS_FORCE_LOCALE_KEY);
  }

  const storedLocale = localStorage.getItem(LS_LOCALE_KEY)?.toLowerCase();

  const tgLocale = WebApp?.initDataUnsafe?.user?.language_code?.toLowerCase();

  if (tgLocale && isValidLocale(tgLocale)) {
    if (storedLocale !== tgLocale) localStorage.setItem(LS_LOCALE_KEY, tgLocale);

    return tgLocale;
  }

  const osLoc = `${window.navigator.language}`.split('-')[0]?.toLowerCase();

  if (osLoc && isValidLocale(osLoc)) {
    if (storedLocale !== osLoc) localStorage.setItem(LS_LOCALE_KEY, osLoc);
    return osLoc;
  }

  if (storedLocale && isValidLocale(storedLocale)) {
    return storedLocale;
  }

  return DEFAULT_LOCALE;
};
